// useFetchCouponData.js
import { useCallback } from "react";
import { getDatabase, ref, get } from "firebase/database";

export default function useFetchCouponData() {

    const db = getDatabase();

    // 🧮 Apply Coupon logic
    const applyCoupon = useCallback(async (price, code) => {

        if (!price) { 
            return price;  // If no price, return the original price
        }

        const coupon = (code || "").trim();

        const couponRef = ref(db, `Coupons/${coupon}`);

        try {
            // Fetch coupon data from Firebase
            const snapshot = await get(couponRef);

            if (snapshot.exists()) {

                const data = snapshot.val();

                // Check if coupon is active and not expired
                const currentTime = Date.now();

                if (data.active && currentTime < data.expiresAt) {

                    let finalPrice = price;

                    // Apply discount based on coupon type
                    if (data.type === "percent") {
                        finalPrice = price - (price * data.value) / 100;
                    } else if (data.type === "fixed") {
                        finalPrice = price - data.value;
                    }

                    return finalPrice; // Return the discounted price

                }
            }

            return price; // Return the original price if coupon is invalid

        } catch (error) {
            console.error("Error fetching coupon:", error);
            return price; // Return original price in case of error
        }
    }, [db]);

    return { applyCoupon };
}
